export { default } from './EnergiaSolarBlog';
